export async function logOut(): Promise<boolean> {
    try {
        const response = await fetch('/operations/admin/AJAX-REQUESTS-General.aspx/Log_Me_Out_Of_Toolkit', {
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST'
        });

        const body = await response.json();
        return parseInt(body.d.charAt(0)) === 1;
    } catch (error) {
        console.error(error);
    }

    return false;
}
